import { FeatureCollection } from 'geojson'
import { MAPSTACK_SOURCE_ID, StyleOptions } from 'map-style-utils'
import { useMap } from 'ms-map-gl'
import { FC, useEffect, useMemo } from 'react'
import { useDispatch } from 'react-redux'
import {
  useAggregate,
  useAggregateProperty,
  useDisplay
} from '~map-preview/states/boundaries'
import { addLayerSource } from '~map-preview/states/layer'
import { Boundary2DLayer } from './2D'
import { Boundary3DLayer } from './3D'

type BoundaryLayerProps = {
  geojson: FeatureCollection
}

const BoundaryLayer: FC<BoundaryLayerProps> = (props) => {
  const { geojson } = props

  const dispatch = useDispatch()

  const map = useMap()
  const display = useDisplay()
  const aggregate = useAggregate()
  const aggregatedValue = useAggregateProperty()

  const boundaryStyleOptions: StyleOptions = useMemo(
    () => ({
      // INFO: Format is MS_zz-countries
      aggregateBoundary: `MS_${aggregate.replace(':', '-')}`,
      sourceLayer: aggregate,
      source: MAPSTACK_SOURCE_ID,
      aggregateProperty: aggregatedValue
    }),
    [aggregate, aggregatedValue]
  )

  useEffect(() => {
    if (map) dispatch(addLayerSource(MAPSTACK_SOURCE_ID))
  }, [dispatch, map])

  return (
    <>
      {display === '2D' && (
        <Boundary2DLayer
          key={`boundary-2d-${aggregate}`}
          boundaryStyleOptions={boundaryStyleOptions}
          geojson={geojson}
        />
      )}

      {display === '3D' && (
        <Boundary3DLayer
          key={`boundary-3d-${aggregate}`}
          boundaryStyleOptions={boundaryStyleOptions}
          geojson={geojson}
        />
      )}
    </>
  )
}

export { BoundaryLayer }
